import axiosInstance from "./axiosConfig";

class InvitationServices {

  // Delete an invitation by ID
  static async deleteInvitation(invitationId) {
    try {
      const response = await axiosInstance.delete(process.env.REACT_APP_API_URL+`/invitation/${invitationId}`);
      return response;
    } catch (error) {
      console.error('Error deleting invitation:', error);
      throw error;
    }
  }

  // Read an invitation by ID
  static async getInvitation(invitationId) {
    try {
      const response = await axiosInstance.get(process.env.REACT_APP_API_URL+`/invitation/${invitationId}`);
     return response;
    } catch (error) {
      console.error('Error fetching invitation:', error);
      throw error;
    }
  }

  static async listInvitations() {
    try {
      const response = await axiosInstance.get(process.env.REACT_APP_API_URL+'/invitations');
      return response;
    } catch (error) {
      console.error('Error fetching invitations:', error);
      throw error;
    }
  }

  // Create a new invitation
  static async saveInvitation(invitationData) {
    try {
      const response = await axiosInstance.put(process.env.REACT_APP_API_URL+'/invitation', invitationData);
      return response;
    } catch (error) {
      console.error('Error creating invitation:', error);
      throw error;
    }
  }

  static async saveInvitationAnswers(invitationData) {
    try {
      const response = await axiosInstance.post(process.env.REACT_APP_API_URL+'/invitation/answers', invitationData);
      return response.attributes;
    } catch (error) {
      console.error('Error creating invitation:', error);
      throw error;
    }
  }

}

export default InvitationServices;
